<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex xs12 sm12 d-flex v-for="(detalle, id) in comprobante.gastoDetalles" v-bind:key="id">
        <v-flex xs12 sm9 d-flex>
          <v-text-field label="Detalle" v-model="detalle.gastoDescripcion" v-bind:readonly="disabledComprobante"></v-text-field>
        </v-flex>
        <v-flex xs4 sm2 offset-xs1 d-flex>
          <v-text-field label="Monto" v-model="detalle.gastoMonto" v-bind:readonly="disabledComprobante" v-money></v-text-field>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'venta-manual',
  props: {
    productos: {
      1: {
        nombre: '',
        precio: 0,
        cantidad: 0,
        total: 0,
        urlImg: ''
      }
    },
    disabled: false
  },
  methods: {
    calcularTotal () {
      var total = 0
      for (var idDetalle in this.productos) {
        total += this.productos[idDetalle].total
      }
      this.$emit('total-seleccion', total)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VentaManual.vue